<div class="menu-container" *ngIf="sidenav">
  <button class="menu basic-button" (click)="sidenav.toggle()">
    <mat-icon class="icon material-icons-round">menu</mat-icon></button>
</div>

<a class="company" [routerLink]="[nav_path.home]" [style.height]="'75px'">
  <img class="logo" src="assets/svg/logoGoldRings.svg" [height]="75" [alt]="company.short_name + ' logo'" />
</a>

<div class="auth">
  <ng-container *ngIf="!(authService.user$ | async); else signedIn">
    <button mat-button class="sign-in" [routerLink]="[nav_path.signIn]">Sign in</button>
    <button mat-stroked-button class="sign-up" [routerLink]="[nav_path.signUp]">Sign Up</button>
  </ng-container>

  <ng-template #signedIn>
    <!--  todo: create user header component  -->
    <a aria-expanded="false" [matMenuTriggerFor]="userActions">
      <ng-container *ngIf="authService.user?.photoURL && !userPhotoError; else noPhoto">
        <img class="user-photo"
             (error)="userPhotoError=true"
             [src]="authService.user?.photoURL"
             [alt]="authService.user?.displayName+' profile photo'" />
      </ng-container>
      <ng-template #noPhoto>
        <mat-icon class="material-icons-round user-icon">account_circle</mat-icon>
      </ng-template>
    </a>
    <mat-menu xPosition="before" #userActions="matMenu">
      <button mat-menu-item type="button" *ngFor="let userAction of menuService.userActions" [routerLink]="userAction.routerLink">
        <mat-icon class="material-icons-round">{{userAction.icon}}</mat-icon>{{userAction.name}}
      </button>
      <button mat-menu-item (click)="authService.logout()">
        <mat-icon class="material-icons-round">logout</mat-icon>Sign Out
      </button>
    </mat-menu>
  </ng-template>
</div>
